import { Box, Typography } from '@mui/material';
import { useUserProfileQuery } from 'app/store';
import { CopyButton } from 'components/copy-button/copy-button';

const AccountIdentifier = () => {
    const { data: profile } = useUserProfileQuery();
    const account = profile?.account || '-';

    return (
        <Box
            sx={{
                mb: 3,
                p: { xs: 2, md: 2.5 },
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2.5,
                bgcolor: 'background.paper',
                display: 'flex',
                alignItems: { xs: 'stretch', sm: 'center' },
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 2,
            }}
        >
            <Box sx={{ minWidth: 0 }}>
                <Typography
                    className="font-yekan-heavy"
                    sx={{ fontSize: { xs: 14, md: 16 }, color: 'text.primary' }}
                >
                    شماره حساب کاربری
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ mt: 0.5, color: 'text.secondary' }}
                >
                    شناسه حساب شما در آقای پرداخت
                </Typography>
            </Box>

            <Box
                sx={{
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    p: 1,
                    pl: 1.25,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    bgcolor: 'action.hover',
                }}
            >
                <Typography
                    component="span"
                    dir="ltr"
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        fontFamily: 'monospace',
                        fontSize: 14,
                        overflowWrap: 'anywhere',
                        textAlign: 'left',
                        color: 'text.primary',
                    }}
                >
                    {account}
                </Typography>
                {profile?.account && (
                    <CopyButton
                        value={profile.account}
                        variant="text"
                        sx={{ flexShrink: 0 }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default AccountIdentifier;
